export default "__VITE_PUBLIC_ASSET__7bed7a8a__"